import React from 'react';
import { Pause } from 'lucide-react';
import { OverlayIcon } from './overlay-icon';
import { RewindIcon } from '../../ui/icons/rewind-icon';
import { ForwardIcon } from '../../ui/icons/forward-icon';
import { usePlayerContext } from '../../context/player-context';

export const ActionOverlay: React.FC = () => {
  const { showToggleIcon, isPlaying, currentAction } = usePlayerContext();

  return (
    <>
      {showToggleIcon && !isPlaying && (
        <OverlayIcon>
          <Pause className="w-12 h-12 text-white opacity-75" />
        </OverlayIcon>
      )}

      {currentAction === 'rewind' && (
        <OverlayIcon>
          <RewindIcon />
        </OverlayIcon>
      )}

      {currentAction === 'forward' && (
        <OverlayIcon>
          <ForwardIcon />
        </OverlayIcon>
      )}
    </>
  );
};
